// @flow

import React, { Component } from "react";
import _ from "lodash";
import actions from "@actions";
import { connect } from "react-redux";

// import Config from "@Config";
import ApiFactory from "@apis/APIFactory";
import LoaderCover from "@components/atoms/LoaderCover";
// import ServerErrorMessage from "@components/atoms/ServerErrorMessage";

// import adyenPaymentSession from "@assets/adyenPaymentSession.json"; // debugging

type PropsType = {
    dispatch: any,
    userId?: ?any,
    orderId?: ?any,
    mode?: ?string,
    onLoad: ?any,
    onSubmit?: ?any,
    session: any,
    onProvide?: ?any,
    onError: any,
    orderAmount: number,
    className: ?string,
    onClick?: ?any
};

type StateType = {
    paymentSession: ?any,
    merchantAccount: ?string,
    paypalMerchant: ?string,
    appleMerchant: ?string,
    adyenLoaded: boolean,
    error: ?any,
    clientKey: ?string
};

class AdyenCheckout extends Component<PropsType, StateType> {
    state = {
        paymentSession: null,
        merchantAccount: null,
        paypalMerchant: null,
        appleMerchant: null,
        googlePayMerchant: null,
        clientKey: null,
        adyenLoaded: false,
        error: null
    };

    _isMounted = false;
    adyenCheckout: any = null;
    dropin: any = null;
    adyenCheckoutContainer = React.createRef < any > ();

    componentDidMount() {
        this._isMounted = true;
        this.init();
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (!prevState.paymentSession && this.state.paymentSession) {
            this.initAdyenCheckout();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.dropin) {
            try {
                this.dropin.unmount();
                this.dropin = null;
            } catch (e) {
                console.warn('Error during unmount:', e);
            }
        }
    }

    submit(e: any) {
        if (this.dropin && this.dropin.activePaymentMethod && this.dropin.activePaymentMethod.displayName === "PayPal") {
            console.error(
                "please use paypal button. TODO: hide this green button"
            );
        } else {
            this.dropin.submit();
        }

    }

    init() {
        // clear any existing payment session from state and get new payment session payload
        this.setState(
            {
                paymentSession: null,
                merchantAccount: null,
                paypalMerchant: null,
                appleMerchant: null,
                googlePayMerchant: null,
                clientKey: null
            },
            () => {
                this.getOrderPaymentSession();
            }
        );
    }

    getOrderPaymentSession = () => {
        // get a standard checkout/order payment session token (standard checkout)
        if (this.props.orderId && this.props.userId) {
            ApiFactory.CardAPI.getOrderPaymentSession(this.props.orderId)
                .then((res: any) => {
                    if (this._isMounted) {
                        this.setState({
                            paymentSession: res.payment_methods,
                            merchantAccount: res.adyen_merchant_account,
                            paypalMerchant: res.paypal_merchant_id,
                            appleMerchant: res.apple_merchant_id,
                            googlePayMerchant: res.google_merchant_id,
                            clientKey: res.adyen_client_key
                        });
                    }
                })
                .catch((err: any) => {
                    if (this._isMounted) {
                        this.setState({
                            adyenLoaded: true,
                            error:
                                err.friendly_message ||
                                "Something went wrong whilst initialising the payment session."
                        });
                        if (this.props.onError) {
                            this.props.onError(err);
                        }
                    }
                });
        } else {
            console.error(
                "AdyenCheckout: userId and orderId props were not provided to the AdyenCheckout component."
            );
        }
    };

    handlePaymentOnClick = async (resolve = undefined, reject = undefined) => {        
        if (this._isMounted) {
            if (typeof this.props.onClick === 'function') {
                return await this.props.onClick(resolve, reject);
            }
        }
    };
    

    initAdyenCheckout = async (): any => {
        try {
            this.setState({ adyenLoaded: false });
            // Wait for the DOM node to exist
            const mountNode = document.getElementById('adyen-checkout');
            if (!mountNode) {
                // Try again after a short delay
                setTimeout(this.initAdyenCheckout, 100);
                return;
            }

            // Ensure AdyenWeb is loaded
            if (!window.AdyenWeb) {
                throw new Error("Adyen Web SDK not loaded");
            }

            const { AdyenCheckout, Dropin, Card, PayPal, GooglePay, ApplePay } = window.AdyenWeb;
            // Validate AdyenCheckout instance
            if (!AdyenCheckout || typeof AdyenCheckout !== "function") {
                throw new Error("AdyenCheckout is not a valid function");
            }
            const translations = {
                "en-US": {
                    "creditCard": {
                        "creditCard.cvcField.placeholder": "123",
                        "cardNumber": "Card number",
                        "expiryDate": "Expiry date",
                        "securityCode": "CVC / CVV",
                        "nameOnCard": "Cardholder name",
                        "placeholder": {
                            "cardNumber": "1234 5678 9012 3456",
                            "expiryDate": "MM/YY",
                            "securityCode": "123",
                            "nameOnCard": "J. Smith"
                        }
                    },
                    "saveCard": "Save for my next payment",
                    "secureMessage": "Your credit card details are securely processed by our payment partner."
                }
            };
            // Create AdyenCheckout instance
            const checkout = await AdyenCheckout({
                paymentMethodsResponse: this.state.paymentSession,
                clientKey: this.state.clientKey,
                countryCode: "AU",
                locale: "en-US",
                translations: translations,
                environment: window.hj_env === "prod" ? "live-au" : "test",
                showPayButton: false,
                onSubmit: (state, component, actions) => {
                    try {
                        if (
                            state.data.paymentMethod.type === "applepay" &&
                            !state.data.paymentMethod["applepay.token"]
                        ) {
                            return;
                        }
                        if (!this._isMounted) return;
                        if (this._isMounted) {
                            if (this.props.onSubmit) {
                                this.props.onSubmit(state, component, actions);
                            } else {
                                console.error(
                                    "No onSubmit prop was provided, please include an onSubmit prop that will pass back the paymentData."
                                );
                                actions.reject();
                            }
                        }
                    } catch (error) {
                        console.error("Submit handler error:", error);
                        if (this.props.onError) {
                            this.props.onError(error);
                        }
                        actions.reject();
                    }

                },
                onAdditionalDetails: (state, component) => {
                    try {
                        if (!this._isMounted) return;


                        if (this.props.onProvide) {
                            this.props.onProvide(state, component);
                        } else {
                            console.error(
                                "No onProvide prop was provided, please include an onProvide prop that will pass back the paymentData."
                            );
                        }
                    }
                    catch (error) {
                        console.error("AdditionalDetails handler error:", error);
                        if (this.props.onError) {
                            this.props.onError(error);
                        }
                    }
                },
                onError: (error, component) => {
                    console.error("ADYEN ERROR:", {
                        error: error.toString(),
                        component,
                        stack: error.stack
                    });

                    if (this._isMounted) {
                        this.setState({
                            error: error.message || "Payment processing error"
                        });
                    }

                    if (this.props.onError) {
                        this.props.onError({
                            error,
                            component
                        });
                    }
                }
            });
            if (!checkout || typeof checkout.initialize !== "function" || typeof checkout.createFromAction !== "function") {
                throw new Error("Invalid AdyenCheckout instance");
            }

            const dropinConfig = {
                paymentMethodComponents: [Card, PayPal, GooglePay, ApplePay],
                paymentMethodsConfiguration: {
                    card: {
                        enableStoreDetails: !this.props.session.isGuestUser,
                        hasHolderName: true,
                        holderNameRequired: false,
                        showStoreDetailsCheckbox: true,
                        storeDetailsText: translations["en-US"].saveCard,

                        cvc: {
                            placeholders: {
                                securityCode: '123'
                            }
                        },
                        // Custom placeholder / localization
                        placeholders: {
                            cardNumber: translations["en-US"].creditCard.placeholder.cardNumber,
                            expiryDate: translations["en-US"].creditCard.placeholder.expiryDate,
                            holderName: translations["en-US"].creditCard.placeholder.nameOnCard
                        },

                        styles: {
                            base: {
                                fontSize: '16px',
                                placeholder: {
                                    color: '#C6C7CC',
                                    fontFamily: `Roboto, apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;`,
                                }
                            },

                        },
                        showSecurityCodeTooltip: false,
                        // 2. DOM Manipulation Fallback
                        onLoad: () => {
                            const overrideAllLabels = () => {
                                // 1. Holder Name
                                document.querySelectorAll('[data-id="holderName"]').forEach(el => {
                                    el.textContent = 'Cardholder name';
                                });
                                // 2. Security Code
                                document.querySelectorAll('.adyen-checkout__label__text').forEach(el => {
                                    if (el.textContent.includes('Security code')) {
                                        el.textContent = 'CVC / CVV';
                                    }
                                });
                                // 3. Remove down text under securityCode and expiryDate
                                document.querySelectorAll('.adyen-checkout-contextual-text').forEach(el => {
                                    if (el.textContent.includes('3 digits on back of card') || el.textContent.includes('Front of card in MM/YY format'))
                                        el.style.display = 'none';
                                });
                                // 4. security code placeholder
                                document.querySelectorAll('.adyen-checkout__input--securityCode').forEach(el => {
                                    el.setAttribute('placeholder', '123');
                                });
                                // remove the div class for "Save for my next payment"
                                const storeDetailsElements = document.querySelectorAll('.adyen-checkout__store-details');
                                storeDetailsElements.forEach(element => {
                                    element.classList.remove('adyen-checkout__store-details');
                                });

                            };

                            // Run immediately and periodically
                            overrideAllLabels();
                            const intervalId = setInterval(overrideAllLabels, 500);
                            setTimeout(() => clearInterval(intervalId), 5000);
                        },

                        data: {
                            paymentMethod: {
                                details: [
                                    {
                                        key: 'description',
                                        type: 'text',
                                        text: translations["en-US"].secureMessage
                                    }
                                ]
                            }
                        },
                        onClick: this.handlePaymentOnClick
                    },
                    paypal: {
                        merchantId: this.state.paypalMerchant,
                        environment: window.hj_env === "prod" ? "live" : "test",
                        showPayButton: true,
                        countryCode: "AU",
                        intent: "authorize",

                        amount: {
                            currency: "AUD",
                            value: Math.round(this.props.orderAmount * 100)
                        },
                        onClick: this.handlePaymentOnClick                       

                    },
                    paywithgoogle: {
                        environment: window.hj_env === "prod" ? "live" : "test",
                        showPayButton: true,
                        countryCode: "AU",
                        amount: {
                            currency: "AUD",
                            value: Math.round(this.props.orderAmount * 100)
                        },
                        configuration: {
                            gatewayMerchantId: this.state.merchantAccount,
                            merchantName: window.hj_env === "prod" ? "Hungry Jack's Pty Ltd" : this.state.merchantAccount,
                            merchantId: window.hj_env === "prod" ? this.state.googlePayMerchant : "test_googlePay_merchantId" // for lower env, added dummy merchant id "test_googlePay_merchantId"
                        },
                        paymentDataRequest: {
                            transactionInfo: {
                                totalPrice: String(this.props.orderAmount),
                                totalPriceStatus: "FINAL",
                                currencyCode: "AUD",
                                countryCode: "AU"
                            }
                        },
                        onClick: this.handlePaymentOnClick
                    },
                    applepay: {
                        // Required configuration for Apple Pay
                        amount: {
                            currency: "AUD",
                            value: Math.round(this.props.orderAmount * 100)
                        },
                        countryCode: "AU",
                        showPayButton: true,
                        totalPriceLabel: "Hungry Jack's",
                        configuration: {
                            merchantName: "ApplePay Hungry Jack's",
                            merchantIdentifier: this.state.appleMerchant
                        },
                        onValidateMerchant: (resolve, reject, validationURL) => {
                            ApiFactory.CardAPI.getApplePaySession(
                                validationURL
                            ).then(res => {
                                resolve(res.payment_session);
                            }, reject);
                        },
                        onClick: this.handlePaymentOnClick,
                        onSubmit: (state, dropin) => {
                            if (this._isMounted) {
                                if (this.props.onSubmit) {
                                    this.props.onSubmit(state, dropin);
                                } else {
                                    console.error(
                                        "No onSubmit prop was provided, please include an onSubmit prop that will pass back the paymentData."
                                    );
                                }
                            }
                        }

                    }
                },
                onSelect: (activeComponent) => {
                    if (activeComponent && activeComponent._props) {
                        const method = activeComponent._props.type;
                    }
                }
            };
            // Initialize the Adyen Checkout instance
            this.dropin = new Dropin(checkout, dropinConfig).mount('#adyen-checkout');

            this.setState({ adyenLoaded: true });
            if (this.props.onLoad) {
                this.props.onLoad();
            }
        } catch (error) {
            console.error("Error initializing Adyen Checkout:", error);
            this.setState({
                adyenLoaded: true,
                error: "Failed to initialize payment methods.",
            });
            if (this.props.onError) {
                this.props.onError(error);
            }
        }
    };
    render(): any {
        return (
            <div
                className={
                    `adyen-checkout ` +
                    (this.props.className ? this.props.className : "")
                }
            >
                <LoaderCover solid={true} active={!this.state.adyenLoaded} />
                {/* <ServerErrorMessage>{this.state.error}</ServerErrorMessage> */}
                <div
                    ref={this.adyenCheckoutContainer}
                    id="adyen-checkout"
                    className={`adyen-checkout__wrapper ${this.state.adyenLoaded ? "has-loaded" : ""
                        }`}
                />
            </div>
        );
    }
}

export default connect(
    (state: any): any => ({
        session: state.session
    }),
    null,
    null,
    {
        forwardRef: true
    }
)(AdyenCheckout);
